module.exports = __webpack_public_path__ + "static/media/toggle_closed_btn_icon.dd329f57.svg";